module.exports = __webpack_public_path__ + "img/edit.8a398dd1.svg";